import React, { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from '../App/Hooks/reduxHooks'
import { inlineMediaQuery } from '../App/Util'
import { getCurrentUser } from '../User/Store/actions'

import { MenuItem } from './Components/MenuItem/MenuItem'
import { SettingButton } from './Components/SettingButton/SettingButton'
import { Profile } from './Profile/Profile'

export const Menu = () => {
  const [isAbleToAccessSettings, setIsAbleToAccessSettings] =
    useState<boolean>(false)

  const { t } = useTranslation()
  const currentLocation = useLocation()
  const currentUser = useAppSelector(state => state.users.currentUser)
  const mediaBreak = inlineMediaQuery('(max-width: 767px)')
  const dispatch = useAppDispatch()

  // Temp. patch for the settings buttons
  // will be removed once we fix the back end section
  useEffect(() => {
    if (currentUser && currentUser.permissions) {
      let canAccessSettings = false
      for (const permissionName of Object.keys(currentUser.permissions)) {
        if (
          permissionName.startsWith('settings.') &&
          currentUser.permissions[permissionName]
        ) {
          canAccessSettings = true
          break
        }
      }
      setIsAbleToAccessSettings(canAccessSettings)
    }
  }, [currentUser])

  const menuStructure = [
    {
      icon: 'home',
      title: t('Home'),
      path: '/',
      classNames: ['home'],
      isRender: true,
    },
    {
      icon: 'calendar',
      title: t('Calendar'),
      path: '/calendar',
      classNames: ['calendar'],
      isRender: true,
    },
    {
      icon: 'customers',
      title: t('Customers'),
      path: '/customers',
      classNames: ['customers'],
      isRender: true,
    },
    {
      icon: 'register',
      title: t('Register'),
      path: '/register',
      classNames: ['register'],
      isRender: true,
    },
    {
      icon: 'products',
      title: t('Products'),
      path: '/products',
      classNames: ['products'],
      isRender: true,
    },
    {
      icon: 'punchclock',
      title: t('Human resources'),
      path: '/hr',
      classNames: ['punchclock'],
      isRender: true,
    },
    {
      icon: 'reports',
      title: t('Reports'),
      path: '/report',
      classNames: ['reports'],
      isRender: true,
    },
    {
      icon: 'customers',
      title: t('Profile'),
      path: '/profile',
      classNames: ['profile'],
      isRender: currentLocation.pathname.includes('/profile') && mediaBreak,
    },
  ]

  const [navigationMenu, setNavigationMenu] = useState(menuStructure)

  useEffect(() => {
    if (!currentUser) {
      dispatch(getCurrentUser())
    }
  }, [])

  useEffect(() => {
    if (currentUser && currentUser.permissions) {
      const marketingTabExists = navigationMenu.some(
        navItem => navItem.path === '/marketing' || navItem.icon === 'marketing',
      )

      if (!marketingTabExists) {
        setNavigationMenu([
          ...navigationMenu,
          {
            icon: 'marketing',
            title: t('Marketing'),
            path: '/marketing',
            classNames: ['marketing'],
            isRender: currentUser.permissions.marketingManage,
          },
        ])
      }
    }
  }, [currentUser])

  const menuElements = navigationMenu.map((navItem, i) => {
    const isSelected =
      0 === window.location.pathname.indexOf(navigationMenu[i].path) &&
      navigationMenu[i].path !== '/'
    const classNames = navigationMenu[i].classNames
    if (isSelected) {
      classNames.push('selected')
    }
    return (
      <MenuItem
        key={'menu' + navigationMenu[i].icon + i}
        icon={navigationMenu[i].icon}
        title={navigationMenu[i].title}
        path={navigationMenu[i].path}
        classNames={classNames}
        isRender={navigationMenu[i].isRender}
      />
    )
  })

  return (
    <Fragment>
      {menuElements}
      <div className="seperator" />
      <a
        href={`https://help.optios.net`}
        target="_blank"
        className="minor support"
        title={t('Support')}
        rel="noreferrer">
        <i className="icon icon-on icon-support" />
        <i className="icon icon-off icon-support-neg" />
      </a>
      {/* Leave this section because*/}
      {/* hasAccessToSettings will be fixed from the Back-end*/}
      {/* {currentUser && currentUser.permissions.hasAccessToSettings ? (*/}
      {isAbleToAccessSettings ? <SettingButton /> : null}
      <Profile />
    </Fragment>
  )
}
